<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content">
      <h2>用户管理</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForm"
          class="search-form"
          size="small"
        >
          <el-form-item label="平台用户" prop="platformId">
            <el-select
              style="width: 215px"
              v-model="searchForm.platformId"
              placeholder="请选择平台用户"
              filterable
              clearable
            >
              <el-option
                v-for="item in platformList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户ID" prop="userId">
            <el-input
              style="width: 215px"
              v-model="searchForm.userId"
              placeholder="请输入用户ID"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="用户昵称" prop="username">
            <el-input
              style="width: 215px"
              v-model="searchForm.username"
              placeholder="请输入用户昵称"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="goodsNo">
            <el-input
              style="width: 215px"
              v-model="searchForm.phone"
              placeholder="请输入手机号码"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否购买商品" prop="brandId">
            <el-select
              style="width: 215px"
              v-model="searchForm.hasShopping"
              placeholder="请选择"
              filterable
              clearable
            >
              <el-option
                v-for="item in hasShoppings"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="加入时间" prop="brandId">
            <el-date-picker
              style="width: 215px"
              v-model="joinTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="最近访问时间" prop="brandId">
            <el-date-picker
              style="width: 215px"
              v-model="lastActiveTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')"
              >查询</el-button
            >
            <el-button type="primary" plain @click="fetchData('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>列表数据</h3>
        <div>
          <el-button type="primary" @click="deriveDeliver">批量导出</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table
          v-loading="loading"
          v-horizontal-scroll="'always'"
          :column="columns"
          :data="page.list"
          pagination
          :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="searchForm.pageNo"
          :page-size="searchForm.pageSize"
          @selection-change="onMultipleSelection"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
        >
        </lb-table>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    LbTable
  },
  data () {
    return {
      dataList: {
        list: [
          { title: '矩阵管理', path: '', type: '0' },
          { title: '用户管理', path: '', type: '1' }
        ]
      },
      lastActiveTime: [],
      joinTime: [],
      hasShoppings: [
        {
          id: 0,
          name: '未购买'
        },
        {
          id: 1,
          name: '已购买'
        },
      ],
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        platformId: null,
        userId: '',
        username: '',
        phone: '',
        hasShopping: null,
        joinTimeStart: '',
        joinTimeEnd: '',
        lastActiveTimeStart: '',
        lastActiveTimeEnd: '',
      },
      list: [
        {
          name: '天兰',
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        }
      ],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        { label: '用户ID', prop: 'id', minWidth: '120' },
        {
          label: '用户图片',
          minWidth: '200',
          render: (h, scope) => {
            return (
              <div>
                <el-image src={scope.row.mainImageArr[0]} preview-src-list={scope.row.mainImageArr} lazy></el-image>
              </div>
            )
          }
        },
        { label: '用户昵称', prop: 'username', minWidth: '160' },
        { label: '手机号码', prop: 'phone', minWidth: '120' },
        { label: '平台', prop: 'platformName', minWidth: '120' },
        { label: '加入时间', prop: 'joinTime', minWidth: '180' },
        { label: '最近访问时间', prop: 'lastActiveTime', minWidth: '180' },
        { label: '拥有粉丝数', prop: 'fansCount', minWidth: '100' },
        { label: '可提现佣金', prop: 'commission', minWidth: '100' },
        { label: '是否购买商品', prop: 'hasShopping', minWidth: '120' },
        {
          label: '操作',
          minWidth: '120',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <span style='color:#409EFF;cursor:pointer' onClick={() => { this.todetail(scope.row) }}>查看</span>
              </div >
            )
          }
        }],
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      platformList: [],
      loading: true
    }
  },
  created () {
    this.goodsPlatforms()
    this.fetchData()
  },
  methods: {
    //导出
    deriveDeliver () {
      this.$api.exportUserList(this.searchForm).then(res => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
        }
      })
    },
    downloadlink (url) {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = url
      document.body.appendChild(iframe)
    },
    onMultipleSelection (val) {
      this.selectionGoods = val
    },
    handleCurrentChange (currentChange) {
      this.searchForm.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange (sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.fetchData()
    },
    fetchData (type) {
      if (type == 'reset') {
        this.searchForm = {}
        this.joinTime = []
        this.lastActiveTime = []
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (type == 'search') {
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (this.joinTime) {
        this.searchForm.joinTimeStart = this.joinTime[0]
        this.searchForm.joinTimeEnd = this.joinTime[1]
      } else {
        this.searchForm.joinTimeStart = ''
        this.searchForm.joinTimeEnd = ''
      }
      if (this.lastActiveTime) {
        this.searchForm.lastActiveTimeStart = this.lastActiveTime[0]
        this.searchForm.lastActiveTimeEnd = this.lastActiveTime[1]
      } else {
        this.searchForm.lastActiveTimeStart = ''
        this.searchForm.lastActiveTimeEnd = ''
      }

      this.$api.getUserList(this.searchForm).then(res => {
        if (res.code == 0) {
          // let str = 'require(../../../assets/icon_touxiang_80.png)'
          res.data.list.forEach(item => {
            item.mainImageArr = []
            if (item.avatarUrl == '') {
              item.mainImageArr.push('https://fenxiao.muruji.com/internalSystem/71f27eab-8ee0-418f-87ca-06f040c5c876')
            }
            item.mainImageArr.push(item.avatarUrl)
            if (item.fansCount == null) {
              item.fansCount = 0
            }
          })
          this.page.list = res.data.list
          this.page.totalNum = res.data.totalNum
          this.loading = false
        }
      })
    },
    goodsPlatforms () {
      const params = {
        userId: null,
        username: null,
        phone: null,
        vipLevel: null,
        categoryIds: null,
        openTimeStart: null,
        openTimeEnd: null,
        status: 1
      }
      this.$api.goodsPlatforms(params).then((res) => {
        this.platformList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    add () {
      this.$router.push({
        name: 'platListDetail',
        query: {}
      })
    },
    setting () {
      this.$router.push({
        name: 'settingPlatform',
        query: {}
      })
    },
    todetail (row) {
      this.$router.push({
        name: 'userDetail',
        query: {
          id: row.id
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 5px;
}
.title {
  display: flex;
  justify-content: space-between;
}
#base-list {
  margin-top: 20px;
}
:deep(
    #base-list
      .lb-table
      .el-table
      .el-table__body
      .el-table__row
      .el-table__cell:last-child
      .cell
      div
  ) {
  display: inline-block;
  a {
    margin: 0 5px;
  }
}
.search-form {
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    /deep/ .el-form-item__label {
      width: 100px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }
    /deep/ .el-form-item__content {
      display: block;
      margin-left: 100px;
      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>

